import React, { Component } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

import './History.css';

import historyImg01 from '../assets/imgs/history-01.jpg';
import historyImg02 from '../assets/imgs/history-02.jpg';

class History extends Component {
    render() {
        return (
            <div className="Rooms" ref={(div) => (this.appContainer = div)}>
                <Header />
                <div className="Rooms-container">
                    <div className="Room-top"></div>
                    <div className="Room-mid">
                        <div className="Room-header">History</div>
                        <hr />
                        <div className="Room-listing">
                            <p>
                                In the underground vaults of the iconic Union Savings Building located in the heart of Old Pasadena lives, The Bunker Experience.  This underground post-apocalyptic fortress is in the basement of one of Pasadena's oldest and most fascinating landmarks. Constructed in 1896, the historic building has witnessed more than a century of history—and with it, countless haunting stories, mysteries, and local legends.
                            </p>

                            <p>Some say the building is haunted.</p>

                            <p>
                                Perhaps the most famous tale is that of young Sarah Winsor, the daughter of the bank's director. Legend has it, Sarah disappeared beneath the building and was later discovered after becoming trapped inside one of the bank's vaults. Over the years, the story has evolved into one of Old Pasadena's most enduring ghost legends, with many claiming her spirit still wanders the underground halls.
                            </p>

                            <p>
                                Another legend is about three bank robbers who blasted through a vault wall with dynamite during a dramatic heist. As police closed in, the outlaws reportedly escaped into the maze of underground catacombs beneath Old Pasadena. They were never seen again, and their bodies were never recovered.
                            </p>

                            <p>
                                The underground passages themselves have inspired decades of speculation. Hidden tunnels beneath Old Pasadena have long been associated with Prohibition-era bootlegging, secret passageways, and forgotten routes connecting historic buildings throughout the district.
                            </p>

                            <p>                
                                Keeping the original structure of the bank vaults, the basement has been transformed into, The Bunker Experience.  Even though the purpose of this basement changed, the stories and their stamp on this place can still be felt as you walk through the hallways.
                            </p>

                            <p>
                                The Bunker Experience transports guests into a fully immersive post-apocalyptic underground world where survival is everything. Step into the gritty atmosphere of Fallout meets The Last of Us, the space blends cinematic set design, interactive storytelling, and realistic environments to create an unforgettable adventure. The Bunker Experience offers a one-of-a-kind journey through original story-telling and the apocalypse.
                            </p>
                            
                            <div className="History-img"><img src={historyImg01} alt="" /></div>
                            <div className="History-img"><img src={historyImg02} alt="" /></div>
                            
                            <br></br> 
                        </div>
                    </div>
                    <div className="Room-bottom"></div>
                </div>

                <Footer />
            </div>
        );
    }
}

export default History;
